<template>
  <div class="q-mini-card">
    <div class="q-mini-card__label">{{ label }}</div>
    <div class="q-mini-card__value">{{ formattedValue }}</div>
  </div>
</template>

<script>
export default {
  name: "QMiniCard",
  props: {
    label:   { type: String,  required: true },
    value:   { type: [Number, String], default: 0 },
    money:   { type: Boolean, default: false },
    percent: { type: Boolean, default: false },
  },
  computed: {
    formattedValue() {
      if (this.money) {
        return Number(this.value || 0).toLocaleString("es-ES", {
          style: "currency",
          currency: "EUR",
        });
      }
      if (this.percent) {
        return `${Number(this.value || 0).toFixed(1)}%`;
      }
      return this.value ?? 0;
    },
  },
};
</script>

<style scoped>
.q-mini-card {
  border: 1px solid var(--q-border, #1b2532);
  background: var(--q-card, #0e141f);
  border-radius: var(--q-radius, 8px);
  padding: 12px 14px;
}
.q-mini-card__label {
  font-family: var(--q-font-ui, 'Inter', sans-serif);
  font-size: 0.72rem;
  color: var(--q-muted, #7c8ba1);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.3;
}
.q-mini-card__value {
  font-family: var(--q-font-mono, 'JetBrains Mono', monospace);
  font-variant-numeric: tabular-nums;
  font-size: 18px;
  font-weight: 700;
  color: var(--q-text, #e7edf5);
  line-height: 1.4;
}
</style>
